var map = {
	"./cn": 164,
	"./cn.json": 164,
	"./cs": 165,
	"./cs.json": 165,
	"./de": 166,
	"./de.json": 166,
	"./dk": 167,
	"./dk.json": 167,
	"./el": 168,
	"./el.json": 168,
	"./en": 169,
	"./en.json": 169,
	"./es": 170,
	"./es.json": 170,
	"./fr": 171,
	"./fr.json": 171,
	"./gu": 172,
	"./gu.json": 172,
	"./hi": 173,
	"./hi.json": 173,
	"./hr": 174,
	"./hr.json": 174,
	"./hu": 175,
	"./hu.json": 175,
	"./it": 176,
	"./it.json": 176,
	"./kk": 177,
	"./kk.json": 177,
	"./locales": 82,
	"./locales.ts": 82,
	"./lv": 178,
	"./lv.json": 178,
	"./nb": 179,
	"./nb.json": 179,
	"./pl": 180,
	"./pl.json": 180,
	"./pt": 181,
	"./pt.json": 181,
	"./ro": 182,
	"./ro.json": 182,
	"./ru": 183,
	"./ru.json": 183,
	"./tr": 184,
	"./tr.json": 184,
	"./tw": 185,
	"./tw.json": 185,
	"./uk": 186,
	"./uk.json": 186
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 163;